<template>
  <div class="container">
    <div class="desc">
      网速太慢？玩游戏总是卡顿？WiFi5、WiFi6傻傻分不清，新房装修大家都在提的全屋WiFi又是什么？什么样的网络环境才能满足大家的日常电竞游戏体验？什么样的设备又能满足随身出游的需求呢？面对这些问题，普通小白总是各种犯难…为此，京东电脑数码帮你解决所有和网络相关的问题，全场至高8.5折，至高24期免息，部分产品以旧换新至高补贴200元，快来改善一下自己的网络环境吧。
    </div>
    <div class="line">
      <a href="https://pro.m.jd.com/mall/active/3A2opARzfiw9ed8pRjATwKFJrvT/index.html?babelChannel=ttt1" target="_blank">直达主会场</a>
    </div>
    
    <div class="fh">
      <img src="@/assets/jdSignal/pc/fh.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "card",

  components: {},
  data() {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
.container{
  position: relative;
  padding-top: 44px;
  width: 346px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #2C2C2C;
  line-height: 30px;

  .line{
    margin-top: 40px;
    width: 100px;
    height: 32px;
    line-height: 32px;
    background: #6A00D2;
    border-radius: 4px;
    text-align: center;

    a{
      width: 70px;
      height: 20px;
      font-size: 14px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 20px;
    }
  }

  .fh img{
    display: block;
    vertical-align: center;
    height: 37px;
    position: absolute;
    right: -25px;
    bottom: 65px;
  }
}
</style>